import { useMutation } from '@tanstack/react-query';

import { attachExperienceOfferUrgencyTag, detachExperienceOfferUrgencyTag } from '~/services/ExperiencesService';

type AttachExperienceOfferUrgencyTagParams = {
  offerId: string;
  urgencyTagId: string;
};

type DetachExperienceOfferUrgencyTagParams = {
  offerId: string;
  urgencyTagId: string;
};

export function useAttachExperienceOfferUrgencyTag() {
  return useMutation({
    mutationFn: ({ offerId, urgencyTagId }: AttachExperienceOfferUrgencyTagParams) =>
      attachExperienceOfferUrgencyTag(offerId, urgencyTagId),
  });
}

export function useDetachExperienceOfferUrgencyTag() {
  return useMutation({
    mutationFn: ({ offerId, urgencyTagId }: DetachExperienceOfferUrgencyTagParams) =>
      detachExperienceOfferUrgencyTag(offerId, urgencyTagId),
  });
}
